import { FC } from 'react';

import Select, { SelectProps } from 'components/Select';
import { optionsConfig } from 'components/PaymentType';

import { PaymentType } from '__generated__/PaymentType_payment.graphql';

const keys: PaymentType[] = ['BANK_TRANSFER', 'CASH'];

type Props = SelectProps;

const PaymentTypeSelect: FC<Props> = props => (
  <Select keys={keys} optionsConfig={optionsConfig} {...props} />
);

export default PaymentTypeSelect;
